<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          Automatic Upload PO Configuration
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9> </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs2 class="pt-2">
                <span class="subtitle-2 font-weight-600 lightblack--text"
                  >Date</span
                >
              </v-flex>
              <v-flex xs1 class="text-right pr-5 pt-2">
                :
              </v-flex>
              <v-flex xs4>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      placeholder="Multiple Date"
                      append-icon="event"
                      outlined
                      hide-details
                      dense
                      class="pt-0 mt-0"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="date"
                    multiple
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 class="mb-5 mt-3">
                <span class="fs-12">
                  Automatic upload PO will disable on selected date(s).
                </span>
              </v-flex>
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-row class="px-5">
              <v-flex xs2 class="pt-4">
                <span class="subtitle-2 font-weight-600 lightblack--text"
                  >Time</span
                >
              </v-flex>
              <v-flex xs1 class="text-right pr-5 pt-4">
                :
              </v-flex>
              <v-flex xs6>
                <date-picker
                  v-model="time"
                  type="time"
                  format="HH"
                  placeholder="Time (hour)"
                  class="timePicker mt-2"
                  style="width: 66.7% !important;"
                >
                </date-picker>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <span class="fs-12">
                  Automatic upload PO will enable at specified time.
                </span>
              </v-flex>
            </v-row>
          </v-flex>
        </v-card-text>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 class="mb-5 mr-3">
            <v-btn
              id="saveBtn"
              color="blue darken-2"
              class="white--text"
              block
              @click="save()"
              :disabled="isDisable"
            >
              Save
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../../mixins/ACLMixin';
import moment from 'moment';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      items: [],
      time: null,
      date: [],
      isDisable: false,
      end_date: '',
      isActive: false,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      search: '',
      menu: false,
      validationMessage: '',
      menu2: false,
      active: false,
      breadcrumbs: [
        {
          text: 'Configuration',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Automatic Upload PO',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      timeout: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.getDate();
      await this.getTime();
    },
    getDate() {
      this.progressDialogLoading = true;
      let params = {
        year: moment(new Date()).format('YYYY')
      };
      return this.$store
        .dispatch('configuration/getPODate', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.date = data.data.result.map(item => {
              return moment(item).format('YYYY-MM-DD');
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getTime() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('configuration/getPOTime')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            let time = moment(new Date()).set('hour', data.data.hour);
            this.time = time._d;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    save() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to config update automatic upload?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.updateDate();
        }
      });
    },
    updateDate() {
      this.progressDialogLoading = true;
      let params = {
        dates: this.date
      };
      return this.$store
        .dispatch('configuration/updatePODate', params)
        .then(data => {
          if (data.code === 200) {
            this.updateTime();
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    updateTime() {
      this.progressDialogLoading = true;
      let params = {
        hour: moment(this.time).format('HH')
      };
      return this.$store
        .dispatch('configuration/updatePOTime', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: `${data.message.text_en}`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.timePicker .mx-input {
  height: 40px !important;
  border: 1px solid #999 !important;
}
.timePicker .mx-icon-calendar,
.mx-icon-clear {
  right: 15px !important;
}
.timePicker .mx-input:hover,
.timePicker .mx-input:focus {
  border-color: #000 !important;
}
</style>
